import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';
import { FileService } from '../services/file.service';
import { FilterService } from '../services/filter.service';
import { Observable } from 'rxjs';
import * as _ from 'lodash';
import { NewFileModalComponent } from './new-file-modal/new-file-modal.component'
import { FileUploaderService } from '../services/file-uploader.service';
import { AddQuizModalComponent } from '../quiz/add-quiz-modal/add-quiz-modal.component';
import { Router } from '@angular/router';

@Component({
  selector: 'material-files',
  templateUrl: './files.component.html',
  styleUrls: ['./files.component.scss']
})

export class FilesComponent implements OnInit, OnChanges {
  files = [];
  copyFiles;
  @Input('materialObject') materialObject: any;
  @Input('materialId') materialId: any;
  @Input('folder') folder: any;
  @Input('onCompleteItem') newfile: any;
  @Input('filesFromMaterialTile') filesFromMaterialTile
  @Input('type') type;
  @Input('sessionType') sessionType;
  @Input('userRole') userRole;


  @Output() getFileDetails: EventEmitter<any> = new EventEmitter<any>();
  materials: any;
  fileCount: number;
  currentUser: any;
  hideAction: boolean = false;
  previousIndex: any;
  user: any;
  constructor(public _filter: FilterService, public _newFileUploadService: FileUploaderService, public dialog: MatDialog, public _snackBar: MatSnackBar, public _fileService: FileService, public router: Router) {
  }

  ngOnChanges(changes: import("@angular/core").SimpleChanges): void {

    console.log('New File In Files::::::::::::::::::::::::::::::', this.newfile);

    // console.log("SOMETHING CHANGED!!", this.materialId);
    console.log("SOMETHING CHANGED!!", changes);
    if (this.materialId != undefined) {
      this.files = this.filesFromMaterialTile
      this.copyFiles = this.filesFromMaterialTile
      // this.getFiles();
    }
    if (this.folder != undefined) {
      this.files = this.folder.files;
      this.fileCount = this.files ? this.files.length : 0
    }
    if (this.newfile) {
      console.log('New File In Files::::::::::::::::::::::::::::::', this.newfile);
      this.files.push(this.newfile)
    }
    if (changes.userRole && changes.userRole.currentValue) this.userRole = changes.userRole.currentValue

  }

  ngOnInit() {
    console.log("MAterial object ======> ", this.materialObject)
    console.log("getting all input materialId =========>  ", this.materialId)
    console.log("getting all input folder =========>  ", this.folder)
    console.log("getting all input onCompleteItem =========>  ", this.newfile)
    console.log("getting all input filesFromMaterialTile =========>  ", this.filesFromMaterialTile)
    console.log("getting all input type =========>  ", this.type)
    console.log("getting all input sessionType =========>  ", this.sessionType)
    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    this.hideAction = (this.user.isClient || this.user.isLearner || this.user.isTrainer || this.user.isIQA) ? true : false
    console.log("Initialized Files component by", this.files, { materialId: this.materialId });
    if (this.materialId != undefined) {
      this.files = this.filesFromMaterialTile
      this.fileCount = this.files ? this.files.length : 0
      // this.getFiles();
    }
  }


  // MODALS
  addFileModal() {
    console.log("THIS.TYPE", this.type, this.sessionType)
    let tempKey = this.type == 'session' ? 'sessionId' : 'materialId'
    console.log('tempKey: this.materialId, sessionType: this.sessionType', "tempKey", this.materialId, "sessionType", this.sessionType);
    if (this.materialId != undefined) {
      let addedCourse = this.openDialog(NewFileModalComponent, { tempKey: this.materialId, sessionType: this.sessionType }).subscribe((fileQueue) => {
        console.log("The queue recieved is", fileQueue.length);
        if (fileQueue == undefined || fileQueue.length == 0) return;
        _.forEach(fileQueue, (file) => {
          this.files.push(file);
        })
        console.log("this.files After push", this.files);

        this.openSnackBar("File uploaded successfully!", "Ok");
        this.updateData(this.files);
        this.fileCount = this.files.length;
      }, err => {
        return this.openSnackBar("Something went wrong!", "Ok");
      });
    }
    else if (this.folder != undefined) {
      this.openDialog(NewFileModalComponent, { folderId: this.folder._id }).subscribe(file => {
        console.log("file in folder", file);
        if (file == undefined) return
        _.forEach(file, (data) => {
          this.files.push(data);
        })
        this.fileCount = this.files.length;
      })
    }
    console.log("onCompleteItem from file upload service");


    // this.getFiles();
  }
  updateData(courses: any) {
    // throw new Error("Method not implemented.");
  }
  courses(courses: any) {
    throw new Error("Method not implemented.");
  }
  fileDetails(event) {
    console.log("Event in material-files", event);
    this.previousIndex = event.index
    this.getFileDetails.emit(event)
  }

  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { disableClose: true, width: "1000px", data });
    return dialogRef.afterClosed();
  }

  applyFilter(filterValue: string) {
    console.log('Filtered Value====>>', filterValue, this.copyFiles);
    // this.copyFiles = this.files;
    this.files = this._filter.filter(filterValue, this.copyFiles, ['title', 'type']);
    this.updateData(this.files);
  }


  deletedFile(event) {
    console.log("File Deleted Event : ", event);
    this.openSnackBar("File deleted successfully!", "Ok");
    this.files.splice(this.files.findIndex(function (i) {
      return i._id === event._id;
    }), 1);
  }

  addQuizModal() {
    let obj = {
      sessionType: this.sessionType,
      sessionId: this.materialId,
      isEdit: false
    }
    this.openDialog(AddQuizModalComponent, obj).subscribe(res => {
      console.log('RES', res)
      if (!res) return
      else {
        this.router.navigate(['/create-quiz'], { queryParams: { quizId: res._id } })
      }
    })
  }

  // API
  getFiles() {
    console.log("Getting files in files component for materialID = ", this.materialId);
    this._fileService.getFilesByMaterial(this.materialId)
      .subscribe(files => {
        console.log("Response from service", files);
        // this.copyFiles = files;
        this.files = files;
        console.log("Files updated with - ", files);
        this.fileCount = this.files.length;
      })
  }
}
